import { Link } from '@remix-run/react';

import Typography from '~/components/Typography';
import type { Publication } from '~/interfaces/publication';
import getNormalizedCategory from '~/utils/getNormalizedCategory';

import Section from './Section';

interface Props {
  publication: Publication;
  textColor: any;
  fontFamily: string;
  isNewWebBuilder?: boolean;
}

const CategoriesWidgetSection = ({ publication, textColor, fontFamily, isNewWebBuilder = false }: Props) => {
  return (
    <Section
      text="Categories"
      viewMoreLink={`/t/${getNormalizedCategory(publication.content_tags?.[0]?.display)}`}
      textColor={textColor}
      fontFamily={fontFamily}
      isNewWebBuilder={isNewWebBuilder}
    >
      <div className="flex flex-wrap gap-2">
        {publication.content_tags?.map((tag) => {
          return (
            <Link
              key={tag.id}
              to={`/t/${tag.display}`}
              style={{
                borderColor: textColor,
              }}
              className="font-regular mb-2 ml-0 cursor-pointer rounded-full border px-4 py-2 text-xs"
            >
              <Typography
                as="span"
                color={textColor}
                fontFamily={fontFamily}
                fontFamilyv2={isNewWebBuilder ? fontFamily : undefined}
                size="sm"
                className="truncate font-medium"
              >
                {tag.display}
              </Typography>
            </Link>
          );
        })}
      </div>
    </Section>
  );
};

export default CategoriesWidgetSection;
